/**
 * @generated SignedSource<<1146c510a5b291b78c5a99ed2f823eb2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftItemImportErrorReason = "NFT_ITEM_IMPORT_ERROR_REASON_DUPLICATE_ID" | "NFT_ITEM_IMPORT_ERROR_REASON_INVALID_MEDIA" | "NFT_ITEM_IMPORT_ERROR_REASON_INVALID_METADATA" | "NFT_ITEM_IMPORT_ERROR_REASON_MEDIA_PROCESSING_ERROR" | "NFT_ITEM_IMPORT_ERROR_REASON_UNKNOWN_ERROR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewNftTile_nftItem$data = {
  readonly importErrorReason: NftItemImportErrorReason | null;
  readonly metadata: {
    readonly name?: string | null;
  } | null;
  readonly mostRecentAuction: {
    readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuction">;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftItem" | "NftProfileImportCollectionRetry_nftItem">;
  readonly " $fragmentType": "NftProfileImportCollectionViewNftTile_nftItem";
};
export type NftProfileImportCollectionViewNftTile_nftItem$key = {
  readonly " $data"?: NftProfileImportCollectionViewNftTile_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewNftTile_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionViewNftTile_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "importErrorReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludeCanceled",
          "value": true
        }
      ],
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "mostRecentAuction",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftItemTile_nftAuction"
        }
      ],
      "storageKey": "mostRecentAuction(excludeCanceled:true)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionRetry_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTile_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "1f335d8f8f7592e02ee4675fffb8b168";

export default node;
